export const BERLIN_TIME_ZONE = 'Europe/Berlin';

export const POSTAL_COST = 3.9;
